import React from "react";
import { FaChevronRight } from "react-icons/fa";
import TrustBadgesFooter from "../../../components/TrustBadgesFooter";

const CartStickyFooter = ({
  grandTotal = 0,
  cartCount = 0,
  onCheckout,
  loading = false,
  checkoutBlocked = false,
  isAuthenticated = true,
}) => {
  return (
    <>
      {/* Sticky Bottom Bar */}
      <div className="sticky bottom-0 z-40 bg-white rounded-xl border border-gray-200 p-3 sm:p-4 shadow-lg my-4">
        <div className="flex items-center justify-between gap-3">
          {/* Total Payable */}
          <div className="flex flex-col">
            <span className="text-[10px] sm:text-xs text-gray-500 font-medium">
              Total Payable
            </span>
            <span className="text-[9px] sm:text-[10px] text-gray-400">
              (Incl. of all taxes)
            </span>
            <span className="text-lg sm:text-xl font-black text-[#046a38]">
              ₹{grandTotal.toFixed(2)}
            </span>
          </div>

          {/* Items Count Badge */}
          <div className="hidden sm:flex flex-col items-center justify-center rounded-lg border border-gray-200 bg-gray-50 px-4 py-1.5 text-center">
            <span className="text-[10px] text-gray-500 font-medium">
              No. of Products
            </span>
            <span className="text-xs font-bold text-gray-900">
              {cartCount} Items
            </span>
          </div>

          {/* Checkout Button */}
          <button
            onClick={onCheckout}
            disabled={loading || checkoutBlocked}
            className={`flex items-center justify-center gap-2 rounded-xl px-6 py-3 text-sm font-bold text-white shadow-md transition-all disabled:cursor-not-allowed disabled:opacity-60 ${checkoutBlocked ? "bg-red-600 hover:bg-red-600" : "bg-[#046a38] hover:bg-[#03522b] active:scale-95"}`}
          >
            {loading ? (
              <>
                <svg className="h-4 w-4 animate-spin text-white" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                </svg>
                <span>Checking Stock…</span>
              </>
            ) : (
              <>
                <span>
                  {checkoutBlocked
                    ? "Remove unavailable items"
                    : isAuthenticated ? "Proceed to Checkout" : "Login to Proceed"}
                </span>
                {!checkoutBlocked && <FaChevronRight className="h-3.5 w-3.5" />}
              </>
            )}
          </button>
        </div>
      </div>

      {/* Trust Badges */}
      <TrustBadgesFooter />
    </>
  );
};

export default CartStickyFooter;
